/* HeySunday — Environmental Impact page — scoped to #ei-instrument and elements inside .ei-page */
(function () {
  function init() {
    var root = document.querySelector('.ei-page');
    if (!root) return;

    // Fade-in on scroll
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    root.querySelectorAll('.fadein').forEach(function (el) { io.observe(el); });

    // Tick marks on each gauge
    function buildTicks(groupId) {
      var g = document.getElementById(groupId);
      if (!g) return;
      var cx = 200, cy = 220, rInner = 138, rMajorOuter = 154, rMinorOuter = 148;
      var svgNS = 'http://www.w3.org/2000/svg';
      for (var i = 0; i <= 20; i++) {
        var t = i / 20, angle = Math.PI * (1 - t), isMajor = (i % 2 === 0);
        var rOut = isMajor ? rMajorOuter : rMinorOuter;
        var x1 = cx + rInner * Math.cos(angle), y1 = cy - rInner * Math.sin(angle);
        var x2 = cx + rOut * Math.cos(angle),  y2 = cy - rOut * Math.sin(angle);
        var line = document.createElementNS(svgNS, 'line');
        line.setAttribute('x1', x1.toFixed(1)); line.setAttribute('y1', y1.toFixed(1));
        line.setAttribute('x2', x2.toFixed(1)); line.setAttribute('y2', y2.toFixed(1));
        line.setAttribute('class', 'gauge-tick-mark ' + (isMajor ? 'major' : 'minor'));
        g.appendChild(line);
      }
    }
    buildTicks('plasticTicks');
    buildTicks('waterTicks');

    // Real-world dosing constants
    var BOTTLE_SIZE_OZ           = 50;
    var CLAIMED_LOADS_PER_BOTTLE = 32;
    var REAL_DOSE_MULTIPLIER     = 2.0;
    var LOADS_PER_BOTTLE         = CLAIMED_LOADS_PER_BOTTLE / REAL_DOSE_MULTIPLIER;
    var PLASTIC_LB_PER_BOTTLE    = 0.29;
    var WATER_FRAC_LIQUID        = 0.70;
    var OZ_OF_LIQUID_PER_LOAD    = BOTTLE_SIZE_OZ / LOADS_PER_BOTTLE;
    var WATER_OZ_PER_LOAD        = OZ_OF_LIQUID_PER_LOAD * WATER_FRAC_LIQUID;
    var OZ_PER_GAL               = 128;

    function computeImpact(lpw, yrs) {
      var loads = lpw * 52 * yrs;
      var bottles = loads / LOADS_PER_BOTTLE;
      var plastic = bottles * PLASTIC_LB_PER_BOTTLE;
      var waterOz = loads * WATER_OZ_PER_LOAD;
      var waterGal = waterOz / OZ_PER_GAL;
      return {
        loads:    Math.round(loads),
        bottles:  Math.round(bottles),
        plastic:  Math.round(plastic),
        water:    Math.round(waterGal),
        waterLbs: Math.round(waterGal * 8.34)
      };
    }

    var ARC_LENGTH = Math.PI * 160;
    var BOTTLE_MAX = 1500;
    var WATER_MAX_GAL = 500;

    function setGauge(arcEl, needleEl, value, max) {
      var pct = Math.max(0, Math.min(1, value / max));
      arcEl.style.strokeDasharray = (ARC_LENGTH * pct).toFixed(1) + ' 1400';
      needleEl.style.transform = 'rotate(' + (-90 + (180 * pct)).toFixed(1) + 'deg)';
    }

    function rollNumber(el, target) {
      var formatted = target.toLocaleString('en-US');
      if (el._lastFormatted === formatted) return;
      el._lastFormatted = formatted;
      el.innerHTML = '';
      var wrap = document.createElement('span'); wrap.className = 'roll-wrap';
      for (var i = 0; i < formatted.length; i++) {
        var ch = formatted[i];
        var col = document.createElement('span');
        col.className = 'roll-col' + (ch === ',' ? ' comma' : '');
        if (ch === ',') { col.textContent = ','; }
        else {
          var strip = document.createElement('span'); strip.className = 'roll-strip';
          for (var d = 0; d <= 9; d++) { var dg = document.createElement('span'); dg.textContent = d; strip.appendChild(dg); }
          var v = parseInt(ch, 10);
          strip.style.transform = 'translateY(0%)';
          requestAnimationFrame(function (s, val) { return function () { s.style.transform = 'translateY(-' + (val * 10) + '%)'; }; }(strip, v));
          col.appendChild(strip);
        }
        wrap.appendChild(col);
      }
      el.appendChild(wrap);
    }

    var loadsSlider = document.getElementById('loadsSlider');
    var yearsSlider = document.getElementById('yearsSlider');
    var loadsValueEl = document.getElementById('loadsValue');
    var yearsValueEl = document.getElementById('yearsValue');
    var plasticArc = document.getElementById('plasticArc');
    var plasticNeedle = document.getElementById('plasticNeedle');
    var waterArc = document.getElementById('waterArc');
    var waterNeedle = document.getElementById('waterNeedle');
    var plasticReadout = document.getElementById('plasticReadout');
    var waterReadout = document.getElementById('waterReadout');
    var plasticLbsEl = document.getElementById('plasticLbs');
    var waterPounds = document.getElementById('waterPounds');
    var formulaLoadsEl = document.getElementById('formulaLoads');
    var formulaBottlesEl = document.getElementById('formulaBottles');
    var formulaPlasticEl = document.getElementById('formulaPlastic');
    var formulaWaterEl = document.getElementById('formulaWater');
    var bottleWaterEl = document.getElementById('bottleWater');
    var bottleDetergentEl = document.getElementById('bottleDetergent');
    var tunerResetBtn = document.getElementById('tunerReset');
    var instrumentEl = document.getElementById('instrument');

    if (!loadsSlider || !yearsSlider || !plasticArc || !waterArc) return;

    function updateSliderFill(sl) {
      var min = parseFloat(sl.min), max = parseFloat(sl.max), val = parseFloat(sl.value);
      sl.style.setProperty('--pct', (((val - min) / (max - min)) * 100) + '%');
    }

    function update() {
      var lpw = parseFloat(loadsSlider.value), yrs = parseFloat(yearsSlider.value);
      loadsValueEl.innerHTML = (lpw % 1 === 0) ? lpw.toFixed(0) : lpw.toFixed(1);
      yearsValueEl.innerHTML = yrs.toFixed(0);
      updateSliderFill(loadsSlider); updateSliderFill(yearsSlider);
      var r = computeImpact(lpw, yrs);
      setGauge(plasticArc, plasticNeedle, r.bottles, BOTTLE_MAX);
      setGauge(waterArc, waterNeedle, r.water, WATER_MAX_GAL);
      rollNumber(plasticReadout, r.bottles);
      rollNumber(waterReadout, r.water);
      plasticLbsEl.textContent = r.plastic.toLocaleString('en-US');
      waterPounds.textContent = r.waterLbs.toLocaleString('en-US');
      formulaLoadsEl.textContent = r.loads.toLocaleString('en-US');
      formulaBottlesEl.textContent = r.bottles.toLocaleString('en-US');
      formulaPlasticEl.textContent = r.plastic + ' lb';
      formulaWaterEl.textContent = r.water + ' gal';
    }

    function primeZero() {
      setGauge(plasticArc, plasticNeedle, 0, BOTTLE_MAX);
      setGauge(waterArc, waterNeedle, 0, WATER_MAX_GAL);
      plasticReadout.textContent = '0';
      waterReadout.textContent = '0';
      updateSliderFill(loadsSlider); updateSliderFill(yearsSlider);
    }
    primeZero();

    var gaugeFired = false;
    var gaugeIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !gaugeFired) { gaugeFired = true; setTimeout(update, 220); }
      });
    }, { threshold: 0.35 });
    if (instrumentEl) gaugeIO.observe(instrumentEl);

    loadsSlider.addEventListener('input', function () { if (!gaugeFired) gaugeFired = true; update(); });
    yearsSlider.addEventListener('input', function () { if (!gaugeFired) gaugeFired = true; update(); });
    if (tunerResetBtn) tunerResetBtn.addEventListener('click', function () { loadsSlider.value = 5; yearsSlider.value = 60; update(); });

    // Bottle fill animation
    var bottleFired = false;
    var bottleIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !bottleFired) {
          bottleFired = true;
          setTimeout(function () { if (bottleWaterEl) bottleWaterEl.style.height = '70%'; }, 200);
          setTimeout(function () { if (bottleDetergentEl) bottleDetergentEl.style.height = '30%'; }, 200);
        }
      });
    }, { threshold: 0.3 });
    var liquidVisualEl = root.querySelector('.liquid-visual');
    if (liquidVisualEl) bottleIO.observe(liquidVisualEl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
